
const ADMKeyWords = ["_DEV","_INT","_PRJ","_OPS","_INTOPS","ITNOVEM_ARCHI","_OWNERS","DGNUM_CDC_CLOUD","CLOUDOPS","EA_ADMIN","_ADM"];

export function isPrivilegedGroup(group){

    //Les groupes à privilèges doit ne comporter que des comptes ADM
    //Groupes à privilèges : AZ_*_DEV, AZ_*_INT, AZ_*_PRJ, AZ_*_OPS, *_INTOPS, AZ_ITNOVEM_ARCHI, *_OWNERS, AZ_DGNUM_CDC_CLOUD, *CLOUDOPS*
    return ADMKeyWords.some(keyword=> group.displayName.includes(keyword));
}
